import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { Box } from '@mui/material';
import Menu from '@/components/menu';
import {
  getChipSummary,
  getFieldValue,
  hasFieldValues,
  SingleFilterHeaderFieldControlProps,
} from './helpers';
import { SegmentField } from './segment-field';
import FilterField from './filter-field';

const useStyles = createUseStyles({
  menuContent: {
    outline: 'none',
  },
  filterField: {
    maxWidth: 400,
    minWidth: 0,
  },
});

const SegmentedFieldMenu: FC<SingleFilterHeaderFieldControlProps> = ({
  field,
  values,
  setValueForColumn,
  setColumnToDefault,
}) => {
  const styles = useStyles();
  const { columnName, label, control = 'select', options = [] } = field;
  const displayLabel = label || columnName;
  const currentValue = getFieldValue(values, columnName);
  const summary = getChipSummary(control, currentValue, options);
  const showClear = hasFieldValues(control, currentValue, options);

  const triggerEl = (
    <SegmentField
      className={styles.filterField}
      leftLabel={displayLabel}
      leftActive={showClear}
      rightValue={summary.value}
      rightExtraCount={summary.extraCount}
      onClear={showClear ? () => setColumnToDefault(columnName) : undefined}
    />
  );

  return (
    <Menu
      menuId={`filter-header-${columnName}`}
      trigger={triggerEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Box className={styles.menuContent}>
        <FilterField
          field={field}
          values={values}
          setValueForColumn={setValueForColumn}
          setColumnToDefault={setColumnToDefault}
        />
      </Box>
    </Menu>
  );
};

export default SegmentedFieldMenu;
